import { Chip } from '@mui/material';

const priorityColors: Record<string, 'default' | 'error' | 'warning' | 'info'> = {
  urgent: 'error',
  high: 'warning',
  medium: 'info',
  low: 'default'
};

interface PriorityChipProps {
  record?: any;
  source: string;
}

export const PriorityChip = ({ record, source }: PriorityChipProps) => {
  const priority = record?.[source];
  if (!priority) return null;

  return (
    <Chip
      label={priority.toUpperCase()}
      color={priorityColors[priority] || 'default'}
      size="small"
    />
  );
};
